export default function Subscription() {
    return <div>Subscription Page</div>;
}
